<template>
    <b-container class="col-9 mt-5">
        <p tabindex="-1" id="about-para-1" v-to-lang class="text-justify lead" v-html="$t('what_is_unterm')"></p>
        <p v-to-lang class="text-justify lead" v-html="$t('about_unterm')"></p>
        <p v-to-lang class="text-justify lead" v-html="$t('unterm_portal')"></p>
        <p v-to-lang class="text-justify lead" v-html="$t('unterm_language')"></p>
        <p v-to-lang class="text-justify lead" v-html="$t('unterm_about_portal')"></p>
    </b-container>
</template>
<script>
    import messagesAbout from "../Lang/About/About-lang"
    export default {
        i18n: {
            messages: {
                ...messagesAbout,
            }
        }
    }
</script>
<style>
</style>
